import { PesIcon } from '@pes-ui/components-react';

export const ActionItemCtaLabelWithIcon = ({ labelName, iconName, iconSize }) => (
  <>
    <PesIcon className="actions-block__cta-icon" size={iconSize}>{iconName}</PesIcon>
    <span className="actions-block__cta pes-link">{labelName}</span>
  </>
);